import { TeachingHall } from '../../../lib/types/models/ol/teaching-hall/teaching-hall'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export interface CenterTeachingHallInput {
  teachingHallId: number
}

export interface CenterTeachingHallRequest extends CenterTeachingHallInput {
  centerId: number
}

export async function assignCenterTeachingHall(input: CenterTeachingHallRequest) {
  const { centerId, teachingHallId } = input

  return restApiClient
    .url(constructApiUrl(API.centers.assignTeachingHall.url, { id: centerId, teachingHallId }))
    .post<TeachingHall>()
}

export async function unassignCenterTeachingHall(input: CenterTeachingHallRequest) {
  const { centerId, teachingHallId } = input

  return restApiClient
    .url(constructApiUrl(API.centers.unassignTeachingHall.url, { id: centerId, teachingHallId }))
    .post<TeachingHall>()
}
